var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2174 11.945L13.3124 11.7275C13.0884 11.7012 12.8614 11.726 12.6483 11.8C12.4353 11.8741 12.2418 11.9954 12.0824 12.155L10.7024 13.535C8.57331 12.4522 6.84276 10.7216 5.75992 8.59249L7.14742 7.20499C7.46992 6.88249 7.62742 6.43249 7.57492 5.97499L7.35742 4.08499C7.3149 3.71913 7.13932 3.38167 6.8641 3.13688C6.58888 2.89209 6.23325 2.75706 5.86492 2.75749H4.56742C3.71992 2.75749 3.01492 3.46249 3.06742 4.30999C3.46492 10.715 8.58742 15.83 14.9849 16.2275C15.8324 16.28 16.5374 15.575 16.5374 14.7275V13.43C16.5449 12.6725 15.9749 12.035 15.2174 11.945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNo);
export default __webpack_public_path__ + "static/media/mobileNo.43ff62167500c2bf6e7d1bff63091bc9.svg";
export { ForwardRef as ReactComponent };